import { RootState } from '../store';

export const selectAuth = (state: RootState): any => state.auth;
